import React from 'react';
import { stepComponent } from './stepComponent';
import { ITransportDetailSection } from 'types/transport';

type Props = ITransportDetailSection & {
    step: string;
};

const StepRender: React.FC<Props> = ({
    step,
    detailInfo,
    transportInfo,
    type,
    loading
}) => {
    // step이 빈 문자열일 경우 방지
    const normalizedStep = step ? step.replace(/_/g, '').toLowerCase() : '';
    const StepComponent = stepComponent[normalizedStep];

    if (!step) {
        return null; // 또는 로딩/대기 상태 처리
    }

    return StepComponent ? (
        <StepComponent
            detailInfo={detailInfo}
            type={type}
            transportInfo={transportInfo}
            loading={loading}
        />
    ) : (
        <div>존재하지 않는 단계입니다: {step}</div>
    );
};

export default StepRender;